export const KEY_ACCOUNT_LIST = 'accountList';
export const KEY_ACCOUNT_REGISTER = 'accountRegister';
export const KEY_ACCOUNT_ROLE_LIST = 'accountRoleList';
export const KEY_ACCOUNT_ROLE_CHANGE = 'accountRoleChange';
export const KEY_ACCOUNT_LOGIN_HISTORY = 'accountLoginHistory';

export const KEY_BOOK_INFO_LIST = 'bookInfoList';
export const KEY_BOOK_GROUP_LIST = 'bookGroupList';
export const KEY_BOOK_GROUP_CATEGORY_LIST = 'bookGroupCategoryList';
export const KEY_BOOK_GROUP_CATEGORY_IMAGE_LIST = 'bookGroupCategoryImageList';

export const KEY_CLASS_READ_RANK_LIST = 'classReadRankList';
export const KEY_CLASS_USER_STAT_LIST = 'classUserStatList';
export const KEY_CLASS_WALK_RANK_LIST = 'classWalkRankList';
export const KEY_CLASS_WRITE_RANK_LIST = 'classWriteRankList';
export const KEY_CLASS_WRITE_LIST = 'classWriteList';
export const KEY_CLASS_MONTHLY_MEMBER_LIST = 'classMonthlyMemberList';
export const KEY_CLASS_MONTHLY_READ_RANK_LIST = 'classMonthlyReadRankList';
export const KEY_CLASS_MONTHLY_WALK_RANK_LIST = 'classMonthlyWalkRankList';
export const KEY_CLASS_MONTHLY_WRITE_RANK_LIST = 'classMonthlyWriteRankList';
export const KEY_CLASS_MONTHLY_AVERAGE_READ_RANK_LIST =
  'classMonthlyAverateReadRankList';
export const KEY_CLASS_MONTHLY_AVERAGE_WALK_RANK_LIST =
  'classMonthlyAverateWalkRankList';
export const KEY_CLASS_MONTHLY_AVERAGE_WRITE_RANK_LIST =
  'classMonthlyAverateWriteRankList';
export const KEY_CLASS_MONTHLY_READ_MEDAL_LIST = 'classMonthlyReadMedalList';
export const KEY_CLASS_MONTHLY_WALK_MEDAL_LIST = 'classMonthlyWalkMedalList';
export const KEY_CLASS_MONTHLY_WRITE_MEDAL_LIST = 'classMonthlyWriteMedalList';
export const KEY_CLASS_READ_ACHIEVEMENT_RANK = 'classReadAchievementRank';
export const KEY_CLASS_WALK_ACHIEVEMENT_RANK = 'classWalkAchievementRank';
export const KEY_CLASS_WRITE_ACHIEVEMENT_RANK = 'classWriteAchievementRank';
export const KEY_CLASS_DAILY_WALK_ACHIEVEMENT_RANK =
  'classWalkDailyAchievementRank';
export const KEY_CLASS_DAILY_WRITE_ACHIEVEMENT_RANK =
  'classWriteDailyAchievementRank';
export const KEY_CLASS_DAILY_READ_ACHIEVEMENT_DATA =
  'classDailyReadAchievementData';
export const KEY_CLASS_DAILY_WALK_ACHIEVEMENT_DATA =
  'classDailyWalkAchievementData';
export const KEY_CLASS_DAILY_WRITE_ACHIEVEMENT_DATA =
  'classDailyWriteAchievementData';
export const KEY_CLASS_MONTHLY_READ_ACHIEVEMENT_DATA =
  'classMonthlyReadAchievementData';
export const KEY_CLASS_MONTHLY_WALK_ACHIEVEMENT_DATA =
  'classMonthlyWalkAchievementData';
export const KEY_CLASS_MONTHLY_WRITE_ACHIEVEMENT_DATA =
  'classMonthlyWriteAchievementData';

export const KEY_DASHBOARD_MEMO_LIST = 'dashboardMemoList';
export const KEY_DASHBOARD_SHORTCUT_LIST = 'dashboardShortcutList';

export const KEY_EDUCATION_OFFICE_SCHOOL_STAT_LIST =
  'educationOfficeSchoolStatList';
export const KEY_EDUCATION_OFFICE_READ_RANK_LIST =
  'educationOfficeReadRankList';
export const KEY_EDUCATION_OFFICE_WALK_RANK_LIST =
  'educationOfficeWalkRankList';
export const KEY_EDUCATION_OFFICE_WRITE_RANK_LIST =
  'educationOfficeWriteRankList';
export const KEYEDUCATION_OFFICE_WRITE_LIST = 'educationOfficeWriteList';
export const KEY_EDUCATION_OFFICE_MONTHLY_MEMBER_LIST =
  'educationOfficeMonthlyMemberList';
export const KEY_EDUCATION_OFFICE_MONTHLY_READ_STAT_LIST =
  'educationOfficeMonthlyReadStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_WALK_STAT_LIST =
  'educationOfficeMonthlyWalkStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_WRITE_STAT_LIST =
  'educationOfficeMonthlyWriteStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_READ_MEDAL_LIST =
  'educationOfficeMonthlyReadStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_WALK_MEDAL_LIST =
  'educationOfficeMonthlyWalkStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_WRITE_MEDAL_LIST =
  'educationOfficeMonthlyWriteStatList';

export const KEY_EDUCATION_OFFICE_MONTHLY_AVERAGE_READ_STAT_LIST =
  'educationOfficeMonthlyAverateReadStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_AVERAGE_WALK_STAT_LIST =
  'educationOfficeMonthlyAverateWalkStatList';
export const KEY_EDUCATION_OFFICE_MONTHLY_AVERAGE_WRITE_STAT_LIST =
  'educationOfficeMonthlyAverateWriteStatList';
export const KEY_EDUCATION_OFFICE_READ_ACHIEVEMENT_STAT =
  'educationOfficeReadAchievementStat';
export const KEY_EDUCATION_OFFICE_WALK_ACHIEVEMENT_STAT =
  'educationOfficeWalkAchievementStat';
export const KEY_EDUCATION_OFFICE_WRITE_ACHIEVEMENT_STAT =
  'educationOfficeWriteAchievementStat';
export const KEY_EDUCATION_OFFICE_DAILY_READ_ACHIEVEMENT_STAT =
  'educationOfficeDailyReadAchievementStat';
export const KEY_EDUCATION_OFFICE_DAILY_WALK_ACHIEVEMENT_STAT =
  'educationOfficeDailyWalkAchievementStat';
export const KEY_EDUCATION_OFFICE_DAILY_WRITE_ACHIEVEMENT_STAT =
  'educationOfficeDailyWriteAchievementStat';
export const KEY_EDUCATION_OFFICE_MONTHLY_READ_ACHIEVEMENT_DATA =
  'educationOfficeMonthlyReadAchievementData';
export const KEY_EDUCATION_OFFICE_MONTHLY_WALK_ACHIEVEMENT_DATA =
  'educationOfficeMonthlyWalkAchievementData';
export const KEY_EDUCATION_OFFICE_MONTHLY_WRITE_ACHIEVEMENT_DATA =
  'educationOfficeMonthlyWriteAchievementData';
export const KEY_EDUCATION_OFFICE_DAILY_READ_ACHIEVEMENT_DATA =
  'educationOfficeDailyReadAchievementData';
export const KEY_EDUCATION_OFFICE_DAILY_WALK_ACHIEVEMENT_DATA =
  'educationOfficeDailyWalkAchievementData';
export const KEY_EDUCATION_OFFICE_DAILY_WRITE_ACHIEVEMENT_DATA =
  'educationOfficeDailyWriteAchievementData';

export const KEY_PORTAL_READ_RANK_LIST = 'portalReadRankList';
export const KEY_PORTAL_WALK_RANK_LIST = 'portalWalkRankList';
export const KEY_PORTAL_WRITE_RANK_LIST = 'portalWriteRankList';
export const KEY_PORTAL_WRITE_LIST = 'portalWriteList';
export const KEY_PORTAL_MONTHLY_READ_STAT_LIST = 'portalMonthlyReadStatList';
export const KEY_PORTAL_MONTHLY_WALK_STAT_LIST = 'portalMonthlyWalkStatList';
export const KEY_PORTAL_MONTHLY_WRITE_STAT_LIST = 'portalMonthlyWriteStatList';
export const KEY_PORTAL_MONTHLY_READ_MEDAL_LIST = 'portalMonthlyReadMedalList';
export const KEY_PORTAL_MONTHLY_WALK_MEDAL_LIST = 'portalMonthlyWalkMedalList';
export const KEY_PORTAL_MONTHLY_WRITE_MEDAL_LIST =
  'portalMonthlyWriteMedalList';
export const KEY_PORTAL_MONTHLY_SCHOOL_GROUP_READ_STAT_LIST =
  'portalMonthlySchoolGroupReadStatList';
export const KEY_PORTAL_MONTHLY_SCHOOL_GROUP_WALK_STAT_LIST =
  'portalMonthlySchoolGroupWalkStatList';
export const KEY_PORTAL_MONTHLY_SCHOOL_GROUP_WRITE_STAT_LIST =
  'portalMonthlySchoolGroupWriteStatList';

export const KEY_PORTAL_MONTHLY_AVERAGE_READ_STAT_LIST =
  'portalMonthlyAverateReadStatList';
export const KEY_PORTAL_MONTHLY_AVERAGE_WALK_STAT_LIST =
  'portalMonthlyAverateWalkStatList';
export const KEY_PORTAL_MONTHLY_AVERAGE_WRITE_STAT_LIST =
  'portalMonthlyAverateWriteStatList';
export const KEY_PORTAL_MONTHLY_AVERAGE_SCHOOL_GROUP_READ_STAT_LIST =
  'portalMonthlyAverateSchoolGroupReadStatList';
export const KEY_PORTAL_MONTHLY_AVERAGE_SCHOOL_GROUP_WALK_STAT_LIST =
  'portalMonthlyAverateSchoolGroupWalkStatList';
export const KEY_PORTAL_MONTHLY_AVERAGE_SCHOOL_GROUP_WRITE_STAT_LIST =
  'portalMonthlyAverateSchoolGroupWriteStatList';
export const KEY_PORTAL_READ_ACHIEVEMENT_STAT = 'portalReadAchievementStat';
export const KEY_PORTAL_WALK_ACHIEVEMENT_STAT = 'portalWalkAchievementStat';
export const KEY_PORTAL_WRITE_ACHIEVEMENT_STAT = 'portalWriteAchievementStat';
export const KEY_PORTAL_DAILY_READ_ACHIEVEMENT_STAT =
  'portalDailyReadAchievementStat';
export const KEY_PORTAL_DAILY_WALK_ACHIEVEMENT_STAT =
  'portalDailyWalkAchievementStat';
export const KEY_PORTAL_DAILY_WRITE_ACHIEVEMENT_STAT =
  'portalDailyWriteAchievementStat';
export const KEY_PORTAL_MONTHLY_READ_ACHIEVEMENT_DATA =
  'portalMonthlyReadAchievementData';
export const KEY_PORTAL_MONTHLY_WALK_ACHIEVEMENT_DATA =
  'portalMonthlyWalkAchievementData';
export const KEY_PORTAL_MONTHLY_WRITE_ACHIEVEMENT_DATA =
  'portalMonthlyWriteAchievementData';
export const KEY_PORTAL_DAILY_READ_ACHIEVEMENT_DATA =
  'portalDailyReadAchievementData';
export const KEY_PORTAL_DAILY_WALK_ACHIEVEMENT_DATA =
  'portalDailyWalkAchievementData';
export const KEY_PORTAL_DAILY_WRITE_ACHIEVEMENT_DATA =
  'portalDailyWriteAchievementData';
export const KEY_PORTAL_MONTHLY_STAT = 'portalMonthlyStat';

export const KEY_SCHOOL_LIST = 'schoolList';
export const KEY_SCHOOL_CLASS_LIST = 'schoolClassList';
export const KEY_SCHOOL_CLASS_STAT_LIST = 'schoolClassStatList';
export const KEY_SCHOOL_GRADE_SCHOOL_CLASS_LIST = 'schoolGradeSchoolClassList';
export const KEY_SCHOOL_READ_RANK_LIST = 'schoolReadRankList';
export const KEY_SCHOOL_WALK_RANK_LIST = 'schoolWalkRankList';
export const KEY_SCHOOL_WRITE_LIST = 'schoolWriteList';
export const KEY_SCHOOL_WRITE_RANK_LIST = 'schoolWriteRankList';
export const KEY_SCHOOL_MONTHLY_MEMBER_LIST = 'schoolMonthlyMemberList';
export const KEY_SCHOOL_MONTHLY_READ_STAT_LIST = 'schoolMonthlyReadStatList';
export const KEY_SCHOOL_MONTHLY_WALK_STAT_LIST = 'schoolMonthlyWalkStatList';
export const KEY_SCHOOL_MONTHLY_WRITE_STAT_LIST = 'schoolMonthlyWriteStatList';
export const KEY_SCHOOL_MONTHLY_READ_MEDAL_LIST = 'schoolMonthlyReadMedalList';
export const KEY_SCHOOL_MONTHLY_WALK_MEDAL_LIST = 'schoolMonthlyWalkMedalList';
export const KEY_SCHOOL_MONTHLY_WRITE_MEDAL_LIST =
  'schoolMonthlyWriteMedalList';

export const KEY_SCHOOL_MONTHLY_AVERAGE_READ_STAT_LIST =
  'schoolMonthlyAverateReadStatList';
export const KEY_SCHOOL_MONTHLY_AVERAGE_WALK_STAT_LIST =
  'schoolMonthlyAverateWalkStatList';
export const KEY_SCHOOL_MONTHLY_AVERAGE_WRITE_STAT_LIST =
  'schoolMonthlyAverateWriteStatList';
export const KEY_SCHOOL_READ_ACHIEVEMENT_STAT = 'schoolReadAchievementStat';
export const KEY_SCHOOL_WALK_ACHIEVEMENT_STAT = 'schoolWalkAchievementStat';
export const KEY_SCHOOL_WRITE_ACHIEVEMENT_STAT = 'schoolWriteAchievementStat';
export const KEY_SCHOOL_DAILY_READ_ACHIEVEMENT_STAT =
  'schoolDailyReadAchievementStat';
export const KEY_SCHOOL_DAILY_WALK_ACHIEVEMENT_STAT =
  'schoolDailyWalkAchievementStat';
export const KEY_SCHOOL_DAILY_WRITE_ACHIEVEMENT_STAT =
  'schoolDailyWriteAchievementStat';
export const KEY_SCHOOL_MONTHLY_READ_ACHIEVEMENT_DATA =
  'schoolMonthlyReadAchievementData';
export const KEY_SCHOOL_MONTHLY_WALK_ACHIEVEMENT_DATA =
  'schoolMonthlyWalkAchievementData';
export const KEY_SCHOOL_MONTHLY_WRITE_ACHIEVEMENT_DATA =
  'schoolMonthlyWriteAchievementData';
export const KEY_SCHOOL_DAILY_READ_ACHIEVEMENT_DATA =
  'schoolDailyReadAchievementData';
export const KEY_SCHOOL_DAILY_WALK_ACHIEVEMENT_DATA =
  'schoolDailyWalkAchievementData';
export const KEY_SCHOOL_DAILY_WRITE_ACHIEVEMENT_DATA =
  'schoolDailyWriteAchievementData';

export const KEY_USER_DETAIL_INFO = 'userDetailInfo';
export const KEY_USER_LIST = 'userList';
export const KEY_USER_LIST_BY_PHONENOS = 'userListByPhonenos';
export const KEY_USER_READ_LIST = 'userReadList';
export const KEY_USER_STEP_LIST = 'userStepList';
export const KEY_USER_WRITE_LIST = 'userWriteList';
export const KEY_USER_WRITE_STAT_LIST = 'userWriteStatList';

// KEY WORD LIST
export const KEY_WORD_EMAIL = 'email';
export const KEY_WORD_PHONE = 'phone';

export const KEY_READ_TEXT = '읽기';
export const KEY_WRITE_TEXT = '쓰기';
export const KEY_WALK_TEXT = '걷기';

export const KEY_CUMULATIVE = 'cumulative';
export const KEY_AVERAGE = 'average';
export const KEY_MEDAL = 'medal';

export const KEY_CLASS = 'class';
export const KEY_SCHOOL = 'school';
export const KEY_EDUCATION_OFFICE = 'educationOffice';
export const KEY_PORTAL = 'portal';
